import request from '@/utils/request'
//微信分享
export function wxSignatureVerification(data) {
  return request({
     url: '/app/wechat/getWxConfig',
    method: 'post',
    data
  })
}